module.exports = __webpack_public_path__ + "static/tb-b9ac8c106f397d4ee10fef5c0a11ce02.png";